<script>
import { Scatter } from 'vue-chartjs'

export default {
    extends: Scatter,
    
    name: "Chart",
    
    props: {
        value: Object,
        unit: String,
        noanimation: Boolean
    },

    data: function(){
        return{
            backgroundColor: [],
            borderColor: [
                '#4dc9f6',
                '#f67019',
                '#f53794',
                '#537bc4',
                '#acc236',
                '#166a8f',
                '#00a950',
                '#58595b',
                '#8549ba'
            ],

            options:null
        }

    },
    mounted(){
        this.options={
            showLines:true,
            responsive: true, 
            maintainAspectRatio: false,
            animation: (!this.noanimation)?{duration: 500}:{duration: 0},
            scales: {
                xAxes: [{
                    type: 'time',
                    time: {
                        displayFormats: {
                            hour: 'hA'
                        }
                    }
                }],
                yAxes: [{
                    scaleLabel :{
                        display: true,
                        fontSize: 14,
                        labelString: (this.unit)?this.unit:""
                    }
                }]
            },
            chartArea: {
                backgroundColor: 'rgba(251, 85, 85, 0.4)'
            }
        }


        let fake = {datasets:[]}
        this.renderChart(fake, this.options)
    },
    watch:{
        value: function(){

            for(var index in this.value.datasets){
                var element = this.value.datasets[index]
                element.borderColor = [ this.borderColor[index] ]
                element.spanGaps = true;
                element.showLine = true;
            }
            this.renderChart(this.value, this.options)

        },
        unit: function(){
            this.options.scales.yAxes[0].scaleLabel.labelString = this.unit
            this.renderChart(this.value, this.options)
        },
        noanimation: function(){
            this.options.animation = (!this.noanimation)?{duration: 500}:{duration: 0}
        }
    }
}
</script>